import { FC } from 'react'

import { customerStore } from '@/store/CustomerStore'

import { StatusCard } from './StatusCard'
import { IAuthPromptProps } from './types'

export const AuthPrompt: FC<IAuthPromptProps> = ({ isLoading = false }) => (
  <StatusCard
    title="Авторизуйтесь"
    description="Чтобы принять участие в акции и забрать свою награду"
    buttonText="Войти"
    onButtonClick={() => customerStore.login()}
    isButtonDisabled={isLoading}
  />
)
